import React from 'react';
import { Trail } from '../types/trail.types';
import { useTranslation } from 'react-i18next';
import { Timeline, Empty, Typography } from 'antd';
import { formatDate } from '../../../../../utils/date.util';

const { Text } = Typography;

interface TrailDetailsComponentProps {
  data: Trail[];
}

const TrailDetailsComponent: React.FC<TrailDetailsComponentProps> = ({ data }) => {
  const { t } = useTranslation();

  if (!data?.length) {
    return <Empty description={t('trails.empty')} />;
  }

  return (
    <Timeline
      items={data.map((trail) => ({
        children: (
          <div key={trail.id}>
            <Text strong className="text-capitalize">
              {trail.action}
            </Text>
            <br />
            <Text type="secondary">
              {trail.actionBy.email} • {trail.createdAt ? formatDate(trail.createdAt) : '-'}
            </Text>
          </div>
        ),
        color: 'blue',
      }))}
    />
  );
};

export default TrailDetailsComponent;
